import axios from 'axios';

const URL = process.env.REACT_APP_API_URL;

const AXIOS = axios.create({
  baseURL: URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const getInitialData = () => AXIOS.get('api/initial-data');

export const getLayers = id => AXIOS.get(`api/capas/${id}`);

export const search = data => AXIOS.get('api/search', {
  params: data,
});

export default AXIOS;
